export const getBaseUrl = (): string => {
  return process.env.VUE_APP_ROOT_API;
};
